import React from 'react';
import { useNavigate } from 'react-router-dom';
import Slider from 'react-slick';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';

const CustomArrow = ({ direction, onClick }) => {
    return (
        <button
            onClick={onClick}
            className={`absolute z-30 top-1/2 -translate-y-1/2 ${direction === 'prev' ? '-left-14' : '-right-14'} 
            w-14 h-14 flex items-center justify-center bg-gray-100 bg-opacity-80 rounded-full shadow-md transition-all duration-300 hover:bg-opacity-100`}
            aria-label={direction === 'prev' ? 'Previous slide' : 'Next slide'}
        >
            {direction === 'prev' ? (
                <FontAwesomeIcon icon={faChevronLeft} className="text-gray-700 text-lg" />
            ) : (
                <FontAwesomeIcon icon={faChevronRight} className="text-gray-700 text-lg" />
            )}
        </button>
    );
};

export default function EmblaCarousel({ slides }) {
    const navigate = useNavigate()
    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: window.innerWidth < 768 ? 1 : parseInt(slides.length) > 4 ? 4 : parseInt(slides.length),
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 1500,
        cssEase: "linear",
        prevArrow: <CustomArrow direction="prev" />,
        nextArrow: <CustomArrow direction="next" />,
        className: "z-10"
    };

    return (
        <div className='w-full relative px-0 lg:px-16 overflow-visible'>
            <Slider {...settings}>
                {slides.map((client, index) => (
                    <div key={index} className='h-[300px] p-[30px] z-0' onClick={()=>navigate(`/brands/${client.t}`)}>
                        <div className='bg-[#E8E3DF] flex justify-center items-center h-[250px] rounded-[20px] cursor-pointer group relative' style={{ backgroundImage: 'none' }}>
                            <div className='absolute inset-0 bg-cover bg-center opacity-0 group-hover:opacity-100 rounded-[20px]' style={{ backgroundImage: `url(${client.bg})` }}></div>
                            <img
                                src={client.h}
                                alt="Hover version"
                                className='hidden w-[150px] h-auto group-hover:block absolute'
                            />
                            <img
                                src={client.v}
                                alt="Default version"
                                className='block w-[150px] h-auto group-hover:hidden absolute'
                            />
                        </div>
                    </div>
                ))}
            </Slider>
        </div>
    );
};

